import { useParams } from 'react-router'
import { useObjectActionMutation, useObjectGet } from '../api/object'
import { Button } from '../components/button'
import { Dialog } from '../components/dialog'
import { usePageLayout } from '../layouts'
import { PageLayout } from '../layouts/page-layout'
import { useToggle } from '../use-toggle'
import { ActionModal } from '../widget/action-modal'
import { Conflicts } from '../widget/conflicts'
import { OverspeedButton, VehicleLocationButton } from './overspeed'
import { OverspeedHistory } from './overspeed-history'

export function Base() {
	const { reservationId = '' } = useParams()
	const { data: reservation, isLoading } = useObjectGet('reservation', reservationId)
	const atdBaseUrl = String(process.env.ATD_PUBLIC_URL ?? '')
		.trim()
		.replace(/\/+$/, '')
	const atdReservationUrl = atdBaseUrl
		? `${atdBaseUrl}/admin/?id=${encodeURIComponent(reservationId)}`
		: null
	const { mutate: cancel } = useObjectActionMutation('reservation', reservationId, 'cancel')
	const { mutate: dispatch } = useObjectActionMutation('reservation', reservationId, 'dispatch')
	const [finish, toggleFinish] = useToggle()
	const [isCancelling, toggleIsCancelling] = useToggle()

	const { layout: pageLayout } = usePageLayout('reservation')
	const openAtdReservation = () => {
		if (!reservationId || !atdReservationUrl) {
			return
		}
		window.location.assign(atdReservationUrl)
	}

	if (isLoading) {
		return (
			<section className="container m-auto">
				<div className="flex items-center gap-4">
					<h3>Rezervace</h3>
				</div>
			</section>
		)
	}

	return (
		<section className="container m-auto">
			<div className="space-y-3 p-4">
				<h3 className="text-md font-bold">
					Rezervace{' '}
					<span className="text-gray-600 font-normal">ID:{reservation?.id}</span>
				</h3>
				{reservation ? (
					<div className="flex flex-wrap items-center gap-2 rounded-xl border border-gray-200 bg-white p-2 shadow-sm">
						{atdReservationUrl ? (
							<Button variant="SECONDARY" onPress={openAtdReservation}>
								Otevřít ATD
							</Button>
						) : null}
						<VehicleLocationButton reservationId={reservationId} />
						<OverspeedButton reservationId={reservationId} />

						{reservation.status !== 'cancelled' ? (
							<>
								<span className="mx-1 hidden h-6 w-px bg-gray-200 sm:block" />
								{reservation.status === 'paid' ? (
									<Button variant="PRIMARY" onPress={() => dispatch({})}>
										Vydat auto
									</Button>
								) : null}
								{reservation.status === 'paid' ||
								reservation.status === 'dispatched' ? (
									<Button variant="PRIMARY" onPress={toggleFinish}>
										Ukončit (vratka)
									</Button>
								) : null}
								{finish ? (
									<ActionModal
										action="finish"
										layout={{
											object: 'reservation',
											name: 'finish',
											dependencies: ['expense', 'payment', 'client'],
										}}
										parent={reservation}
										title="Uzavření"
										onClose={toggleFinish}
									/>
								) : null}
								<Button variant="SECONDARY" onPress={toggleIsCancelling}>
									Zrušit
								</Button>
								{isCancelling ? (
									<Dialog
										heading="Zrušit rezervaci"
										isOpen
										onOpenChange={toggleIsCancelling}
									>
										<div className="m-4">
											<p>Opravdu chcete zrušit rezervaci?</p>
										</div>
										<div className="flex justify-between gap-4 m-4">
											<Button
												variant="DANGER"
												onPress={() => {
													cancel(undefined, {
														onSuccess() {
															toggleIsCancelling(false)
														},
													})
												}}
											>
												Ano
											</Button>
											<Button
												variant="SECONDARY"
												onPress={toggleIsCancelling}
											>
												Ne
											</Button>
										</div>
									</Dialog>
								) : null}
							</>
						) : null}
					</div>
				) : null}
			</div>
			<Conflicts id={reservationId} />
			{pageLayout ? (
				<PageLayout
					object="reservation"
					id={reservationId}
					data={reservation}
					layout={pageLayout}
				/>
			) : null}
			<OverspeedHistory reservationId={reservationId} />
		</section>
	)
}
